<div class="high-alerts">
  <div class="topbar">
    <div class="topbar__left">
      <dsy-content-switcher [contentList]="switchItems" [functionSetterData]="handleSwitch"> </dsy-content-switcher>
    </div>
    <div class="topbar__right">
      @if (selectionStore.selectedCountSignal() == 0 && isCurrentStatus()) {
        <dsy-button [iconSide]="'left'" [iconName]="'download'" [iconLibrary]="'material'" [iconSize]="'1.16rem'" variant="link" color="neutral" (click)="exportCSV()">
          Export CSV
        </dsy-button>
        <dsy-button icon-side="left" icon-name="add" [iconSize]="'1.16rem'" icon-library="material" variant="primary" (click)="handleCreate()"> Create High Alert </dsy-button>
      } @else if (selectionStore.selectedCountSignal() > 0) {
        <dsy-button icon-side="left" icon-name="add" [iconSize]="'1.16rem'" icon-library="material" variant="primary" (click)="handleDeleteAlerts()"> Delete </dsy-button>
      }
    </div>
  </div>

  <dr-ops-stream-ui-high-alerts-filters [options]="filterOptionsSignal()" (filtersChange)="onFiltersChange($event)"> </dr-ops-stream-ui-high-alerts-filters>
  <dr-ops-stream-ui-table-state [isLoading]="isLoadingSignal()" [hasData]="showTableSignal()" [totalItems]="filteredLogsSignal().length" emptyTitle="No high alerts found.">
    <dr-ops-stream-ui-high-alerts-table
      [isCurrentStatus]="isCurrentStatus()"
      [rows]="pagedLogsSignal()"
      (viewAlert)="handleView($event)"
      (editAlert)="handleEdit($event)"
    ></dr-ops-stream-ui-high-alerts-table>
  </dr-ops-stream-ui-table-state>
</div>
